"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const DatahubModuleEditorTypes_1 = require("./DatahubModuleEditorTypes");
const DatahubService_util_1 = __importDefault(require("../DatahubService.util"));
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
class DatahubModuleEditorService {
    static sendModuleCoverEvent({ url, category, eventAction }) {
        const eventData = {
            entity: 'user',
            system: constants_1.SYSTEMS.APP_CLUB_ADMIN,
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: DatahubService_util_1.default.analyticsEventBuilder({
                url,
                category,
                action: eventAction,
                label: constants_1.EVENTS_LABELS.CONTENT.UPLOAD_MODULE_COVER_IMAGE
            })
        };
        event_agent_js_1.default.send(eventData);
    }
}
DatahubModuleEditorService.sendCreateModule = ({ extra, paidModule, publicModule, url }) => {
    let label = DatahubModuleEditorTypes_1.ModuleTypes.Standard;
    if (extra) {
        label = DatahubModuleEditorTypes_1.ModuleTypes.Extra;
    }
    if (label === DatahubModuleEditorTypes_1.ModuleTypes.Standard && publicModule) {
        label = DatahubModuleEditorTypes_1.ModuleTypes.Free;
    }
    if (label === DatahubModuleEditorTypes_1.ModuleTypes.Extra && paidModule) {
        label = DatahubModuleEditorTypes_1.ModuleTypes.Paid;
    }
    DatahubModuleEditorService.sendInteractionClickEvent('CreateModule', `CreateModule_${label}`, url);
};
DatahubModuleEditorService.sendInteractionClickEvent = (category, label, url) => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category,
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            label,
            url
        })
    });
};
exports.default = DatahubModuleEditorService;
